// frontend/src/pages/NoBlogsPage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from '../context/AuthContext';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) =>
    theme.backgroundGradient || 'linear-gradient(135deg, #2cc2d4, #007bff)'};
`;

const Card = styled.div`
  background: white;
  padding: 40px;
  border-radius: 12px;
  max-width: 520px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.15);
`;

const Title = styled.h2`
  margin-bottom: 12px;
`;

const Text = styled.p`
  color: #555;
  margin-bottom: 24px;
`;

const Button = styled.button`
  padding: 12px 20px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-size: 15px;
  background: #007bff;
  color: white;

  &:hover {
    background: #0056b3;
  }
`;

export default function NoBlogsPage() {
  const navigate = useNavigate();
  const { isPlatformAdmin } = useAuth();

  return (
    <Container>
      <Card>
        <Title>No blogs yet</Title>

        {isPlatformAdmin ? (
          <>
            <Text>
              You don’t have any blogs yet. Create your first blog to get started.
            </Text>
            <Button onClick={() => navigate('/create-blog')}>
              Create Blog
            </Button>
          </>
        ) : (
          <>
            <Text>
              You are not a member of any blogs yet.
              Please contact a platform administrator to invite you.
            </Text>
            <Button onClick={() => navigate('/logout')}>
              Log out
            </Button>
          </>
        )}
      </Card>
    </Container>
  );
}
